// Initialize deferredPrompt for use later to show browser install prompt.
export var INSTALL: any

window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    // Stash the event so it can be triggered later.
    INSTALL = e;
    console.log(`'beforeinstallprompt' event was fired.`);
});